"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

var Icon;

if (process.env.NODE_ENV === 'test') {
  // In tests, load synchronously to prevent placeholder/null rendering in snapshots
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  Icon = require('@insided/legacy-icons').default;
} else {
  // In production, use lazy loading to keep bundle size small
  Icon = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", import('../legacy-icons'));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
}

var _default = Icon;
exports.default = _default;